// classes/SniperClass.js
export const SniperClass = {
  id: 'sniper',
  name: 'Sniper',
  description: 'Long-range precision specialist with devastating critical hits',
  icon: '🎯',
  recruitCost: 0,
  
  baseStats: {
    health: 80,
    maxHealth: 80,
    aim: 90,
    mobility: 60,
    defense: 50,
    willpower: 70,
    critChance: 25
  },

  skills: [
    // TIER 1
    {
      id: 'steady_hands',
      name: 'Steady Hands',
      tier: 1,
      xpRequired: 0,
      description: 'Basic marksmanship training. +5 Aim',
      effect: { aim: 5 }
    },
    {
      id: 'headshot',
      name: 'Headshot',
      tier: 1,
      xpRequired: 25,
      description: 'Trained to target vital areas. +10% Critical Chance',
      effect: { critChance: 10 }
    },

    // TIER 2
    {
      id: 'steady_aim',
      name: 'Steady Aim',
      tier: 2,
      xpRequired: 60,
      description: 'Advanced breathing techniques. +10 Aim',
      effect: { aim: 10 }
    },
    {
      id: 'patience',
      name: 'Patience',
      tier: 2,
      xpRequired: 60,
      description: 'Calm under pressure. +15 Willpower',
      effect: { willpower: 15 }
    },

    // TIER 3
    {
      id: 'death_from_above',
      name: 'Death From Above',
      tier: 3,
      xpRequired: 125,
      description: 'Bonus damage when shooting from elevated positions. +30% elevation damage',
      effect: { elevationDamageBonus: 30 }
    },
    {
      id: 'snapfire',
      name: 'Snapfire',
      tier: 3,
      xpRequired: 125,
      description: 'Quick target acquisition. Reduced aim penalty after movement',
      effect: { movementAimPenalty: -50 }
    },

    // TIER 4
    {
      id: 'sharpshooter',
      name: 'Sharpshooter',
      tier: 4,
      xpRequired: 200,
      description: 'Master marksman. +15 Aim, +5% Critical Chance',
      effect: { aim: 15, critChance: 5 }
    },
    {
      id: 'in_the_zone',
      name: 'In The Zone',
      tier: 4,
      xpRequired: 200,
      description: 'Critical hits do not end your turn',
      effect: { critNoTurnEnd: true }
    },

    // TIER 5
    {
      id: 'target_priority',
      name: 'Target Priority',
      tier: 5,
      xpRequired: 300,
      description: 'Extra damage against high-value targets. +25% damage to officers',
      effect: { officerDamageBonus: 25 }
    },
    {
      id: 'combat_awareness',
      name: 'Combat Awareness',
      tier: 5,
      xpRequired: 300,
      description: 'Never caught off guard. +20 Defense',
      effect: { defense: 20 }
    },

    // TIER 6
    {
      id: 'kill_zone',
      name: 'Kill Zone',
      tier: 6,
      xpRequired: 450,
      description: 'Overwatch shots have +40% critical chance',
      effect: { overwatchCritBonus: 40 }
    },
    {
      id: 'executioner',
      name: 'Executioner',
      tier: 6,
      xpRequired: 450,
      description: 'Extra damage against wounded enemies. +30% damage to injured targets',
      effect: { woundedTargetBonus: 30 }
    },

    // TIER 7
    {
      id: 'death_dealer',
      name: 'Death Dealer',
      tier: 7,
      xpRequired: 625,
      description: 'Critical hits deal massive damage. +50% critical damage',
      effect: { critDamageBonus: 50 }
    },
    {
      id: 'ghost',
      name: 'Ghost',
      tier: 7,
      xpRequired: 625,
      description: 'Enemies have reduced chance to detect you. -30% enemy detection range',
      effect: { detectionReduction: 30 }
    },

    // TIER 8
    {
      id: 'one_shot_one_kill',
      name: 'One Shot, One Kill',
      tier: 8,
      xpRequired: 875,
      description: 'First shot of each mission is guaranteed critical hit',
      effect: { firstShotCrit: true }
    },
    {
      id: 'surgical_precision',
      name: 'Surgical Precision',
      tier: 8,
      xpRequired: 875,
      description: 'Ignore cover bonuses on targets. Shots treat all cover as none',
      effect: { ignoreCover: true }
    },

    // TIER 9
    {
      id: 'apex_predator',
      name: 'Apex Predator',
      tier: 9,
      xpRequired: 1250,
      description: 'The ultimate sniper. +25 Aim, +20% Crit Chance, +50% Crit Damage',
      effect: { aim: 25, critChance: 20, critDamageBonus: 50 }
    }
  ],

  abilities: [
    {
      id: 'overwatch',
      name: 'Overwatch',
      unlockAtXP: 0,
      cooldown: 0,
      description: 'Take a reaction shot when an enemy moves in your sight',
      usesPerMission: null
    },
    {
      id: 'disabling_shot',
      name: 'Disabling Shot',
      unlockAtXP: 75,
      cooldown: 3,
      description: 'Wound the target, reducing their aim by 30 and mobility by 20',
      usesPerMission: null
    },
    {
      id: 'deadeye',
      name: 'Deadeye',
      unlockAtXP: 250,
      cooldown: 4,
      description: 'Take a shot with +30 aim and guaranteed critical on hit',
      usesPerMission: 2
    },
    {
      id: 'double_tap',
      name: 'Double Tap',
      unlockAtXP: 500,
      cooldown: 5,
      description: 'Take two shots in one turn against the same target',
      usesPerMission: 1
    },
    {
      id: 'perfect_shot',
      name: 'Perfect Shot',
      unlockAtXP: 1000,
      cooldown: 6,
      description: 'A shot that cannot miss and always critically hits',
      usesPerMission: 1
    }
  ]
};